<img [src]="GetAssetImageLink(_level.iconHash)" class="inline-block rounded-full object-cover aspect-square {{_size}} max-w-min drop-shadow-lg"
     onerror="this.onerror=null;this.src='/assets/missingLevel.svg';" [alt]="_level.title">
